import { useMemo } from "react";
import type { Namen } from "../design/DokumentZeile";
import { personFarbe } from "../design/personFarbe";
import { useAbsender, useKategorien, usePersonen } from "./abfragen";

/** Namen zu IDs fuer Listenzeilen (Absender, Person, Kategorie, Personenfarbe) aus den Stammdaten des Haushalts. */
export function useNamen(): Namen {
  const { data: absender } = useAbsender();
  const { data: personen } = usePersonen();
  const { data: kategorien } = useKategorien();
  return useMemo(() => {
    const a = new Map((absender ?? []).map((x) => [x.id, x.kurzname || x.name]));
    const p = new Map((personen ?? []).map((x) => [x.id, x.name.split(" ")[0] ?? x.name]));
    const k = new Map((kategorien ?? []).map((x) => [x.id, { name: x.name, schluessel: x.schluessel }]));
    return {
      absender: (id) => (id ? a.get(id) : undefined),
      person: (id) => (id ? p.get(id) : undefined),
      kategorie: (id) => (id ? k.get(id) : undefined),
      // Personen-Elemente nur bei mindestens zwei Personen (Plan 6.6)
      farbe: (id, gemeinsam) => ((personen?.length ?? 0) > 1 && (id || gemeinsam) ? personFarbe(personen, id, gemeinsam) : undefined),
    };
  }, [absender, personen, kategorien]);
}
